import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from '../components/Header';
import MainImage from '../components/MainImage';
import OuterDiv from '../components/styledComponents/OuterDiv';
import './index.css';

const IndexLayout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        {
          name: 'google-site-verification',
          content: 'KhkBafYeDL-K1hClsl9A8J7DbRzKqrHxJUHVnV1TozQ',
        },
        // { name: 'description', content: 'Sample' },
        // { name: 'keywords', content: 'sample, something' },
      ]}
    />
    <Header siteTitle={data.site.siteMetadata.title} />
    <MainImage imageData={data.imageSharp} />
    <OuterDiv>{children()}</OuterDiv>
  </div>
);

IndexLayout.propTypes = {
  children: PropTypes.func,
};

export default IndexLayout;

export const query = graphql`
  query SiteIndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    # gets all data for the main site image
    imageSharp(id: { regex: "/.*mario-klassen.*/" }) {
      sizes {
        ...GatsbyImageSharpSizes
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js